import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, filter, map } from 'rxjs';

import { runtimeActions } from '@blaze-runtime/engine-data-access';

import { updateChartWorkflow } from './chart.actions';
import { ChartsFacade } from './charts.facade';

@Injectable()
export class ChartEffects {
  private readonly actions$ = inject(Actions);
  private readonly chartsFacade = inject(ChartsFacade);

  updateChartWorkflow$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateChartWorkflow),
      concatMap(({ elementId }) =>
        this.chartsFacade.getChartWorkflowData(elementId).pipe(
          filter((data) => !!data),
          concatMap((data) => this.chartsFacade.prepareAndUpdateWorkflow(data)),
          map((updatedWf) =>
            runtimeActions.workflowUpdate({
              elementId: elementId,
              workflow: updatedWf,
            }),
          ),
        ),
      ),
    ),
  );
}
